var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report__dashboard_show_coursecompletionoverview_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: 'name',
                title: 'Course name',
                type: 'string',
                sortable: true,
                queryable: false
            },
            {
                key: 'active',
                title: 'Enrolled',
                type: 'number',
                sortable: true,
                queryable: false
            },
            {
                key: 'completed',
                title: 'Completed',
                type: 'number',
                sortable: true,
                queryable: false
            }
        ],"items":_vm.items,"component-table-item":_vm.ReportDashboardShowCourseCompletionOverviewTableItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }